import React, {PropsWithChildren} from 'react';
import {dashboardTheme} from '../../components/Admin/DashboardTheme.ts';
import {ThemeProvider} from '@mui/material';
import {AppGlobalStyles} from '../../style.tsx';

export default function AdminLayout({children}: PropsWithChildren<{}>) {
    return (
        <ThemeProvider theme={dashboardTheme}>
            {AppGlobalStyles}
            {children}
        </ThemeProvider>
    );
}
